import {net} from "./index";

// 获取证书列表的方法
export const getLevels = ({ cate }) => {
	// 设置参数
	let params = new URLSearchParams()

	// 证书分类
	params.append('cate', cate)

	return net.request({
		params: {},
		data: params,
		method: 'post',
		url: '/admin/level/get/list',
	})
}
